import { TaskLabel } from '@seen/core/models/taskLabel/taskLabel'
import { type ReactNode, useCallback } from 'react'
import { LabelCombobox } from '#src/components/LabelCombobox.tsx'
import { useCreateMutation } from '#src/hooks/useCreateMutation.ts'
import { useCurrentPractitioner } from '#src/hooks/useCurrentPractitioner.ts'
import { useSearch } from '#src/hooks/useSearch.ts'

export function TaskLabelCombobox({
  value,
  onChange,
  children,
}: {
  value: string[]
  onChange: (value: string[]) => any
  children: ReactNode
}): ReactNode {
  const { data: labels } = useSearch(TaskLabel, TaskLabel.baseSearchQuery())
  const createMutation = useCreateMutation<TaskLabel>()
  const createTaskLabel = createMutation.mutate
  const currentPractitioner = useCurrentPractitioner()
  const onCreate = useCallback(
    (name: string, color: string) => {
      createTaskLabel(
        new TaskLabel({
          name,
          color,
          author: currentPractitioner.reference,
        }),
        {
          onSuccess: (l) => {
            onChange([...value, l.reference.reference])
          },
        }
      )
    },
    [value, onChange, createTaskLabel, currentPractitioner.reference]
  )
  return (
    <LabelCombobox
      labels={labels}
      value={value}
      onChange={onChange}
      onCreate={onCreate}
      isCreating={createMutation.isPending}
    >
      {children}
    </LabelCombobox>
  )
}
